// extracted by mini-css-extract-plugin
export default {"msg_container":"u2","fromCustomer":"v2","fromRD":"w2","note":"x2","image":"y2","initials":"z2"};
    if(module.hot) {
      // 1713969938796
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  